import PageCard from 'features/shared/components/card/PageCard';
import React from 'react';
import ContactDTO from '../dtos/ContactDTO';
import { ContactType } from '../enums/contactType';
import { ContactGroupType } from '../enums/contactGroupType';
import Contact from './Contact';
import LinkButton from 'features/shared/components/buttons/LinkButton';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  contacts: ContactDTO[];
  count: number;
  contactGroup: ContactGroupType;
  setContactsDialogShow?: React.Dispatch<React.SetStateAction<boolean>>;
  setDialogContactTypes?: React.Dispatch<React.SetStateAction<ContactType[]>>;
  showContactsCount?: number;
}

const ContactsCard = ({ title, contacts, count, contactGroup, showContactsCount = 4, setContactsDialogShow, setDialogContactTypes }: Props) => {
  // translations
  const t = useTranslation("shared\\terms").t;

  // helpers 
  const getContactTypes = (groupType: ContactGroupType):ContactType[] => {
    switch (groupType) {
      case ContactGroupType.Email:
        return [ContactType.Email];
      case ContactGroupType.Telephone:
        return [ContactType.Phone, ContactType.Mobile];
      case ContactGroupType.Other:
        return [ContactType.Url];
      case ContactGroupType.DataBox:
          return [ContactType.DataBox];
      default:
        return [ContactType.Undefined];
    }
  }

  const getContacts = (contacts: ContactDTO[], groupType: ContactGroupType): ContactDTO[] => { 
    let result:ContactDTO[] = [];
    let contactTypes = getContactTypes(groupType);

    for (const contactType of contactTypes) {
      let contactsOfType = contacts.filter(x => x.contactType === contactType);
      if (contactsOfType.length === 0) {
        result.push({ contactType: contactType, value: t("Undefined") });
      } else {
        result.push(...contactsOfType);
      }
    }

    return result;
  }

  // handlers
  const openContactsDialogHandler = () => {
    if (setContactsDialogShow && setDialogContactTypes) {
      let contactTypes = getContactTypes(contactGroup);
      
      setDialogContactTypes(contactTypes);
      setContactsDialogShow(true);
    }
  }

  // sub renders
  const renderContacts = (contacts: ContactDTO[], contactGroup: ContactGroupType): JSX.Element[] => {
    let contactsToRender = getContacts(contacts, contactGroup);

    return contactsToRender.map((contact, index) => 
      <Contact contact={contact} key={index} enableEdit />
    )
  }
  
  // render
  return (
    <PageCard title={title} expandToHeight>
      {renderContacts(contacts, contactGroup)}
      {count > showContactsCount &&
        <div className="text-center mt-2">
          <LinkButton onClick={openContactsDialogHandler} />
        </div>
      }
    </PageCard>
  )
}

export default ContactsCard;
